import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Alert, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import Select from 'react-select'
import { toast } from 'react-toastify';
import {
  editCompanyFieldChange,
  editEmailFieldChange,
  editNumberField,
  editNumberFieldChange as editNumberFieldChangeAction,
  getCompanyNumbers,
  getNumberByID,
  uploadFile,
} from '../../actions/Numbers';
import util from '../../lib/utils';
import CompanyAutocomplete from '../CompanyAutocomplete';
import MultiInput from '../MultiInput';
import NumberTypeSelect from './NumberTypeSelect';
import UsersAutocomplete from './UsersAutocomplete';
import remove from '../../Res/Icon/remove.png';
import NumberRoute from './NumberRoute';
import Toggle from '../Toggle';
import loadingSpinner from '../../Res/loadingSpinner.svg';
import { numberCarrierOptions } from '../../utils/constants';
import ConfirmationModal from '../ConfirmationModal';
import { getPermissionForComponent } from '../../utils/permissionsUtils';
import {
  EFAX_ANALOG_PORT_MESSAGE,
  EFAX_ONE_EMAIL_MESSAGE,
  EFAX_ONE_EMAIL_NOTE,
  T37_INTELIQUENT_TRUNK,
  T37_VOICETEL_ROUTE,
} from '../../lib/constants';
class EditNumberForm extends PureComponent {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');
    this.onNumberChange = this.onNumberChange.bind(this);
    this.state = {
      numDigits: 1,
      spoofType: 'none',
      prepend: false,
      append: false,
      same: false,
      cidOverride: props.number.cidOverride,
      vmailFile: false,
      loadingVmail: true,
      tempType: '',
      warningText:'',
      numberCarrierChangeAccess: false,
      eFaxOnly: props?.number?.onlyEfax ? props?.number?.onlyEfax : false
    };
  }

  async componentDidMount() {
    const uid = true;
    const {
      number,
      getNumberByID,
      editNumberFieldChange,
      getCompanyNumbers,
      editNumberField,
      user
    } = this.props;
    await getCompanyNumbers(this.token, number.company && number.company._id, uid);
    await getNumberByID(this.token, number._id);
    await this.getVmailFile(this.token, number._id);
    editNumberField('numberByID', this.props.numberByID);
    editNumberFieldChange('companyName', number.company && number.company.name);
    editNumberFieldChange('company', number.company && number.company._id);

    const assigned = this.props.number.assignedTo || {};
    editNumberFieldChange('assignedTo', { _id: assigned._id, email: assigned.email });
    editNumberFieldChange('numDigits', 1);
    editNumberFieldChange('cidOverride', number.cid);
    editNumberFieldChange('spoofType', number.spoofType || 'none');
    editNumberFieldChange('carrier', number?.carrier);
    this.handleNumberType({ target: { value: 'spoofType' } }, number.spoofType || 'none');
    const numberCarrierChangeAccessPermission = getPermissionForComponent('numberCarrierChangeAccess',user.permissionsGroup);
    this.setState({ numberCarrierChangeAccess: numberCarrierChangeAccessPermission })
  }

  async getVmailFile(token, numberID){
    if (!numberID) return false;
    try{
      const response = await fetch(`${process.env.REACT_APP_MYEPIK_URL}v2/numbers/vmail-file/${numberID}`, {headers: {Authorization: `Bearer ${token}`}});
      if(!response.ok){
        this.setState({vmailFile: false, loadingVmail: false});
      }
      const data  = await response.json();

      if(data && data.failure){
        this.setState({vmailFile: false, loadingVmail: false});
      }

      this.setState({vmailFile: data, loadingVmail: false});
    }catch(error){
      console.log(error);
      this.setState({vmailFile: false, loadingVmail: false});
    }
  }

  onNumberChange(faxNumber) {
    const { editNumberFieldChange } = this.props;
    editNumberFieldChange('number', faxNumber);
  }

  onEditCompany = async ({ suggestion }) => {
    const uid = true;
    const { editEmailFieldChange, editNumberFieldChange, number } = this.props;

    if (!number.linkedBox) {
      if (suggestion) {
        await this.props.getCompanyNumbers(this.token, suggestion._id, uid);
        editNumberFieldChange('company', suggestion._id);
        editNumberFieldChange('companyID', suggestion._id);
        editNumberFieldChange('companyName', suggestion.name);
        const email = this.props.email && this.props.email.emails[0];
        editEmailFieldChange(this.props.email.emails);
        editNumberFieldChange('assignedTo', { _id: email._id, email: email.email });
      } else {
        editNumberFieldChange('userName', '');
      }
    } else {
      toast.info('Please remove this number from the current Edge Device before changing company.');
    }
  };

  onEditConfirmationEmail = e => {
    this.props.editNumberFieldChange('confirmationEmail', e.target.value);
  };

  onEditEmailChange = ({ name, suggestion }) => {
    if (suggestion) {
      this.props.editNumberFieldChange(name, suggestion._id);
    } else {
      this.props.editNumberFieldChange(name, '');
    }
  };

  applyEfaxRoute = () => {
    const { number, editNumberFieldChange } = this.props;
    if (number?.linkedBox) return;
    if (number?.carrier === 'inteliquent') {
      editNumberFieldChange('trunk', T37_INTELIQUENT_TRUNK);
    }
    if (number?.carrier === 'voicetel') {
      editNumberFieldChange('routeInfo', T37_VOICETEL_ROUTE);
    }
  };

  onNumberTypeSelect = numberType => {
    const { value: selectedType } = numberType || {};
    const { type: currentType, number, editNumberFieldChange } = this.props;

    if (selectedType === 'efax') {
      if (number?.linkedBox) {
        toast.error(EFAX_ANALOG_PORT_MESSAGE);
        return;
      }
      editNumberFieldChange('type', 'fax');
      editNumberFieldChange('onlyEfax', true);
      editNumberFieldChange('savefaxes', false);
      this.setState({ eFaxOnly: true });
      this.applyEfaxRoute();
      return;
    }

    if (currentType === 'fax' && selectedType !== 'fax') {
      this.setState({ tempType: selectedType, warningText: "This change will remove all associated email addresses." });
    }
    else {
      const alreadyEfax = currentType === 'fax' && (this.state.eFaxOnly || number?.onlyEfax);
      if (selectedType === 'fax' && !alreadyEfax) {
        editNumberFieldChange('onlyEfax', false);
        this.setState({ eFaxOnly: false });
      }
      editNumberFieldChange('type', selectedType);
    }
  };

  onUserTypeSelect = numberType => {
    const { editNumberFieldChange } = this.props;
    const number1 = numberType ? numberType?.value : '';
    if (number1 !== '' && number1 !== undefined) {
      editNumberFieldChange('assignedTo', {
        _id: numberType?.value && numberType?.value._id,
        email: numberType?.value && numberType?.value.email,
      });
    }
  };

  onAllowedUserSelect = ({ suggestion }) => {
    const { number } = this.props;
    if (suggestion !== null) {
      let addArray = true;
      number.allowedUsers.forEach(item => {
        if (item._id === suggestion._id) {
          addArray = false;
        }
      });
      if (addArray) {
        this.onEditArrChange([...number.allowedUsers, suggestion], 'allowedUsers');
      }
    }
  };

  onEditUserChange = ev => {
    const { name, value } = ev.target;
    this.props.editNumberFieldChange(name, value);
    this.props.editNumberFieldChange('cidOverride', value);
  };

  onEditArrChange = (ev, type) => {
    if (this.props.type === 'ringDown') {
      if (ev.length > 1) {
        toast.error("You can't add more than one number.");
      } else {
        this.props.editNumberFieldChange(type, ev);
      }
    } else {
      this.props.editNumberFieldChange(type, ev);
    }
  };

  onEditArrNumChange = ev => {
    const { name, value } = ev.target;
    this.props.editNumberFieldChange(name, [value]);
  };

  handleChangeUpload = async ev => {
    this.setState({loadingVmail: true});
    const { files } = ev.currentTarget;
    const file = new FormData();
    file.append('greeting', files[0]);

    await this.props.uploadFile(this.token, this.props.number._id, file);
    await this.getVmailFile(this.token, this.props.number._id);

    this.setState({loadingVmail: false});
  };

  onEditNumberChange = ev => {
    const { name, value } = ev.target;
    const reg = /^[+]*[0-9]{1,11}$/g;
    if (reg.test(value)) {
      this.props.editNumberFieldChange(name, value);
    }
  };

  setCheckedBox = e => {
    this.props.editNumberFieldChange('spoofIncomingCid', e);
  };

  handleNumberDigit = e => {
    if (e.target.value.length <= 1) {
      if (e.target.value >= 0 && e.target.value <= 3) {
        if (e.target.value == 0) {
          // this.setState({ numDigits: 1 }, () => {
          this.props.editNumberFieldChange('numDigits', 1);
          // });
        } else {
          // this.setState({ numDigits: e.target.value }, () => {
          this.props.editNumberFieldChange('numDigits', e.target.value);
          // });
        }
      } else {
        // this.setState({ numDigits: 1 }, () => {
        this.props.editNumberFieldChange('numDigits', 1);
        // });
      }
    }
  };

  handleNumberType = (e, type) => {
    if (type === 'append') {
      this.setState({ append: true });
      this.setState({ prepend: false });
      this.setState({ same: false });
    }
    if (type === 'prepend') {
      this.setState({ prepend: true });
      this.setState({ append: false });
      this.setState({ same: false });
    } else if (type === 'same') {
      this.setState({ append: false });
      this.setState({ prepend: false });
      this.setState({ same: true });
    }
    this.setState({ [e.target.name]: type });
    this.props.editNumberFieldChange(e.target.name, type);
  };

  removeValue = e => {
    const { number, user } = this.props;
    if (user.role !== 'admin') {
      const valuesWIthRemoved = number.allowedUsers.filter((val, idx) => idx !== e);
      this.onEditArrChange(valuesWIthRemoved, 'allowedUsers');
    }
  };

  typeCheck = () => {
    const { number, user } = this.props;
    const myEpik = true;
    if (user.role === 'admin' || user.role === 'enterpriseAdmin') {
      return true;
    }
    if (
      myEpik === true &&
      (number.type === 'dialout' || number.type === 'fax' || number.type === 'vmail' || number.type === 'pri' || number.type === 'sip')
    ) {
      return true;
    }
    return false;
  };
  changeNumberRoute = (e) => {
    const { number, selectRoute, editNumberFieldChange } = this.props;
    const routeUpdate = {};
    if (number.carrier == 'inteliquent') {
      const raw = e.currentTarget.value;
      let trunk = raw;
      try {
        const parsed = JSON.parse(raw);
        trunk = parsed?.trunkGroupName || raw;
      } catch (err) {
        trunk = raw;
      }
      routeUpdate.trunk = trunk;
      editNumberFieldChange('trunk', trunk);
    }
    if (number.carrier == 'voicetel') {
      routeUpdate.routeInfo = {
        route: JSON.parse(e.currentTarget.value).route,
        gateway: JSON.parse(e.currentTarget.value).gateway,
      };
      editNumberFieldChange('routeInfo', routeUpdate.routeInfo);
    }
    if (number.carrier == 'tdm') {
      routeUpdate.tdmRoute = e.currentTarget.value;
      editNumberFieldChange('tdmRoute', routeUpdate.tdmRoute);
    }
    selectRoute(number._id, {
      ...number,
      ...routeUpdate,
      port: number.port || '',
    });
  }

  onCarrierChange = ev => {
    this.props.editNumberFieldChange('carrier', ev?.value);
  };

  hiddenNumberCarrierOptions = (value, numberCarrierChangeAccess) => {
    return value === 'voicetel' || (!(numberCarrierChangeAccess === 'write' || numberCarrierChangeAccess === 'both') && value === 'tdm');
  };

  onCustomWarningCancel = () => {
    this.setState({ warningText: '' });
  };

  onCustomWarningConfirm = () => {
    const { editNumberFieldChange } = this.props;
    editNumberFieldChange('type', this.state.tempType);
    editNumberFieldChange('onlyEfax', false);
    editNumberFieldChange('emails', []);
    editNumberFieldChange('fallbackEmails', []);
    editNumberFieldChange('confirmationEmail', '');
    editNumberFieldChange('faxDeliveryConfirmation', false);
    this.setState({ warningText: '' });
  }

  render() {
    const { companies, type, number, user, email, selectRoute, numberByID } = this.props;
    const { warningText } = this.state;
    const disabledAdmin = user.role === 'admin' || user.role === 'enterpriseAdmin';
    const isEfax = type === 'fax' && !!(this.state.eFaxOnly || number?.onlyEfax);
    const emailCount = number && number.emails ? number.emails.length : 0;
    return (
      <div className="container numbers-container">
        <div className="row">
          <div className="text-left" style={{ width: '100%' }}>
            <FormGroup row>
              <Col sm={6}>
                <Label for="number" sm={12}>
                  Number
                </Label>
                <Input
                  disabled
                  required
                  type="text"
                  name="number"
                  value={number && number.number}
                  onChange={this.onEditNumberChange}
                  maxLength={12}
                />
              </Col>
              <Col sm={3}>
                <Label for="type" sm={12}>
                  Type
                </Label>
                {type === 'callIdMask' ? (
                  <Input type="select" disabled className="w-75">
                    <option>callIdMask</option>
                  </Input>
                ) : (
                  <NumberTypeSelect
                    disabledAdmin={this.typeCheck()}
                    onTypeSelect={this.onNumberTypeSelect}
                    selectedType={type}
                    onlyEfax={isEfax}
                    allowEfax
                    comingFrom="number"
                  />
                )}
              </Col>
              { this.state.numberCarrierChangeAccess && (
                <Col sm={3}>
                <Label for="type" sm={12}>
                  Carrier Type
                </Label>
                <Select
                  options={numberCarrierOptions}
                  onChange={this.onCarrierChange}
                  isOptionDisabled={option =>
                    this.hiddenNumberCarrierOptions(option.value, this.state.numberCarrierChangeAccess)
                  }
                  isDisabled={this.state.numberCarrierChangeAccess === 'read'}
                  value={numberCarrierOptions?.filter(carr => carr.value === number?.carrier)[0]}
                  form="carrier"
                />
              </Col>
              )}
            </FormGroup>
            {user.role === 'superAdmin' ||
              user.role === 'companyGroupAdmin' ||
              user.role === 'supportEngineer' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Company
                  </Label>
                  <CompanyAutocomplete
                    isDisabled={!!numberByID?.linkedBox}
                    searchTerm={number.companyName}
                    placeholder="Filter Company..."
                    companies={companies.docs || []}
                    onChange={this.onEditCompany}
                    subText={
                      numberByID?.linkedBox
                        ? 'This number is assigned to box. Please unassign it to enable this field.'
                        : ''
                    }
                  />
                </Col>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    User
                  </Label>
                  {number && number.assignedTo && number.assignedTo.email ? (
                    <UsersAutocomplete
                      filterValues={'emails'}
                      searchTerm={number && number.assignedTo && number.assignedTo.email}
                      callsItem={(email && email.emails) || []}
                      placeholder="User..."
                      calls={(email && email.emails) || []}
                      onChange={this.onUserTypeSelect}
                      disabledAdmin={disabledAdmin}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Emails not found
                    </Alert>
                  )}
                </Col>
              </FormGroup>
            ) : (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Company
                  </Label>
                  <Input value={user.company && user.company.name} readOnly />
                </Col>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    User
                  </Label>
                  {number && number.assignedTo && number.assignedTo.email ? (
                    <UsersAutocomplete
                      searchTerm={number && number.assignedTo && number.assignedTo.email}
                      callsItem={(email && email.emails) || []}
                      placeholder="User..."
                      calls={(email && email.emails) || []}
                      onChange={this.onUserTypeSelect}
                      disabledAdmin={disabledAdmin}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Emails not found
                    </Alert>
                  )}
                </Col>
              </FormGroup>
            )}
            {type === 'fax' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Email(s)
                    </Label>
                    <MultiInput
                      inputData={number && number.emails ? number.emails : []}
                      onChange={e => {
                        this.onEditArrChange(e, 'emails');
                      }}
                      validator={util.validateEmail}
                      disabledAdmin={disabledAdmin}
                      maxItems={isEfax ? (emailCount > 1 ? emailCount : 1) : undefined}
                      limitNote={isEfax ? EFAX_ONE_EMAIL_NOTE : undefined}
                      maxItemsMessage={isEfax ? EFAX_ONE_EMAIL_MESSAGE : undefined}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Fallback email(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.fallbackEmails) || []}
                      onChange={e => {
                        this.onEditArrChange(e, 'fallbackEmails');
                      }}
                      validator={util.validateEmail}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      {type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'}
                    </Label>
                    <MultiInput
                      inputData={(number && number.forwardUris) || []}
                      onChange={e => {
                        this.onEditArrChange(e, 'forwardUris');
                      }}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                  {!isEfax && (
                    <Col sm={6}>
                      <Label for="savefaxes" sm={12}>
                        Epik Cloud Based Fax Storage
                      </Label>
                      <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                        <Toggle
                          value={number.savefaxes || false}
                          onToggle={() => {
                            if (number && number.forwardUris.length !== 0) {
                              this.onEditArrChange(!!!number.savefaxes, 'savefaxes');
                            } else {
                              toast.info('Forward URI not configured!');
                              console.log('not configured');
                            }
                          }}
                        />
                      </Col>
                    </Col>
                  )}
                </FormGroup>
              </>
            )}
            {type === 'vmail' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Notification email(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.emails) || []}
                      onChange={e => {
                        this.onEditArrChange(e, 'emails');
                      }}
                      validator={util.validateEmail}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                  <Col sm={6}>
                  <Label for="type" sm={12}>
                      Greeting file (*.wav/.mp3 file)
                    </Label>
                    {this.state.loadingVmail ? (
                      <img
                        src={loadingSpinner}
                        alt="greeting file loading"
                        height="100px"
                        width="100px"
                      ></img>
                    ) : (
                      <>
                        <Input
                          type="file"
                          name="greetinFile"
                          accept="audio/mp3,audio/wav,audio/*;"
                          onChange={this.handleChangeUpload}
                          disabled={disabledAdmin}
                        />
                        <div style={{ paddingTop: '10px' }}>
                          {!!this.state.vmailFile ?  (<audio controls src={`data:audio/wav;base64,${this.state.vmailFile}`}/>) : (<p>No Voicemail File Found</p>)}
                        </div>
                      </>
                    )}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Notification number(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.forwardNumbers) || []}
                      onChange={e => {
                        this.onEditArrChange(e, 'forwardNumbers');
                      }}
                      disabledAdmin={disabledAdmin}
                    />
                  </Col>
                </FormGroup>
              </>
            )}
            {type === 'dialout' && (
              <>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Allowed number(s)
                    </Label>
                    <MultiInput
                      inputData={(number && number.allowedNumbers) || []}
                      onChange={e => {
                        this.onEditArrChange(e, 'allowedNumbers');
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Forward number
                    </Label>
                    <Input
                      required
                      type="text"
                      name="forwardNumbers"
                      value={(number && number.forwardNumbers) || []}
                      onChange={this.onEditArrNumChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm={6}>
                    <Label for="type" sm={12}>
                      Caller ID
                    </Label>
                    <Input
                      required
                      type="text"
                      name="cid"
                      value={(number && number.cid) || []}
                      onChange={this.onEditUserChange}
                    />
                  </Col>
                  <Col sm={6}>
                    <Row>
                      <Col sm={12}>
                        <Label for="spoofIncomingCid" sm={6}>
                          <Input
                            type="checkbox"
                            id="spoofIncomingCid"
                            onChange={() => this.setCheckedBox(!number.spoofIncomingCid)}
                            checked={number.spoofIncomingCid}
                            disabled={
                              (number.cid && number.cid.length < 10) ||
                              number.cid === '' ||
                              number.cid === undefined
                            }
                          />
                          Spoof cid
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <Label check sm={3}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'prepend')}
                            disabled={!number.spoofIncomingCid}
                            checked={this.state.prepend}
                          />
                          prepend
                        </Label>
                        <Label check sm={3}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'append')}
                            disabled={!number.spoofIncomingCid}
                            checked={this.state.append}
                          />
                          append
                        </Label>
                        <Label check sm={6}>
                          <Input
                            type="radio"
                            name="spoofType"
                            onChange={e => this.handleNumberType(e, 'same')}
                            disabled={!number.spoofIncomingCid}
                            checked={this.state.same}
                          />
                          Same called number
                        </Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={6}>
                        <Label sm={12} for="numDigits">
                          Number of digits
                        </Label>
                        <Input
                          disabled={
                            !!(
                              number.spoofType === 'same' ||
                              number.spoofType === 'none' ||
                              !number.spoofIncomingCid
                            )
                          }
                          type="number"
                          id="numDigits"
                          name="numDigits"
                          onChange={this.handleNumberDigit}
                          value={number.numDigits}
                          max={3}
                          min={1}
                        />
                      </Col>
                      {this.state.cidOverride && this.state.cidOverride !== '' && (
                        <Col sm={6}>
                          <Label sm={12} for="numDigits">
                            Spoofed Cid
                          </Label>
                          <Input
                            disabled
                            type="text"
                            id="numDigits"
                            name="numDigits"
                            value={this.state.cidOverride}
                          />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </FormGroup>
              </>
            )}

            {type !== 'vmail' &&
              type !== 'dialout' &&
              type !== 'unassigned' &&
              type !== 'fax' &&
              type !== 'forward' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="type" sm={12}>
                    {type === 'ringDown' ? 'Ring Down Number' : 'Forward Uri(s)'}
                  </Label>
                  <MultiInput
                    inputData={(number && number.forwardUris) || []}
                    onChange={e => {
                      this.onEditArrChange(e, 'forwardUris');
                    }}
                    disabledAdmin={disabledAdmin}
                  />
                </Col>
              </FormGroup>
            ) : (
              ''
            )}

            {type === 'fax' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="company" sm={12}>
                    Confirmation email
                  </Label>
                  {number && number.forwardUris.length !== 0 ? (
                    <Input
                      type="email"
                      disabled={disabledAdmin}
                      placeholder="please specify"
                      value={number.confirmationEmail}
                      onChange={this.onEditConfirmationEmail}
                    />
                  ) : (
                    <Alert colSpan={2} color="info" className="price-not-found-alert">
                      Forward URI not configured
                    </Alert>
                  )}
                </Col>
                <Col sm={6}>
                  <Label for="deliveryConfirmations" sm={12}>
                    Delivery Confirmations
                  </Label>
                  <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      value={number.faxDeliveryConfirmation}
                      onToggle={() => {
                        if (number && number.forwardUris.length !== 0 && !disabledAdmin) {
                          this.onEditArrChange(
                            !number.faxDeliveryConfirmation,
                            'faxDeliveryConfirmation',
                          );
                        } else {
                          toast.info('Forward URI not configured!');
                          console.log('not configured');
                        }
                      }}
                    />
                  </Col>
                </Col>
              </FormGroup>
            ) : null}

            {type === 'forward' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="number" sm={12}>
                    Forward Number
                  </Label>
                  <Input
                    required
                    type="text"
                    name="forwardNumbers"
                    value={number?.forwardNumbers ? number.forwardNumbers[0] : ''}
                    onChange={e => this.onEditArrChange([e.currentTarget.value], 'forwardNumbers')}
                    maxLength={12}
                  />
                </Col>
              </FormGroup>
            ) : null}
            {user.role === 'superAdmin' ||
              user.role === 'companyGroupAdmin' ||
              user.role === 'supportEngineer' ? (
              <FormGroup row>
                <Col sm={6}>
                  <Label for="number" sm={12}>
                    Route
                  </Label>
                  <NumberRoute
                    number={number}
                    onChange={this.changeNumberRoute}
                  />
                </Col>
              </FormGroup>
            ) : null}
            {/* <FormGroup row>
              <Col sm={6}>
                <Label for="type" sm={12}>
                  Allowed User(s)
                </Label>
                <UsersAutocomplete
                  disabledAdmin={disabledAdmin}
                  callsItem={(email && email.emails) || []}
                  allowedUsers
                  placeholder="Allowed users"
                  calls={(email && email.emails) || []}
                  onChange={this.onAllowedUserSelect}
                />
                <div className="email-list">
                  {number.allowedUsers.map((value, idx) => {
                    return (
                      <div className="multi-input-item" key={value._id}>
                        <span className="item">{value.email}</span>
                        <img
                          className="remove-icon"
                          src={remove}
                          onClick={() => this.removeValue(idx)}
                          alt="remove"
                        />
                      </div>
                    );
                  })}
                </div>
              </Col>
            </FormGroup> */}
          </div>
        </div>
        <ConfirmationModal
          isOpen={Boolean(warningText)}
          onConfirm={this.onCustomWarningConfirm}
          onCancel={this.onCustomWarningCancel}
          bodyText={warningText}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.AppState.user,
  number: state.UIState.numbers.editNumber,
  numberByID: state.AppState.numbers.numberByID,
  company: state.UIState.numbers.editNumber.company,
  companies: state.AppState.companies,
  type: state.UIState.numbers.editNumber.type,
  email: state.UIState.numbers.filterNumbersByCompany.number,
  emails: state.UIState.numbers.editNumberFieldChange,
});

const mapDispatchToProps = dispatch => ({
  editNumberFieldChange: (name, value) => dispatch(editNumberFieldChangeAction(name, value)),
  editNumberField: (name, value) => dispatch(editNumberField(name, value)),
  editCompanyFieldChange: (name, value) => dispatch(editCompanyFieldChange(name, value)),
  editEmailFieldChange: emails => dispatch(editEmailFieldChange(emails)),
  getCompanyNumbers: (token, id, uid) => dispatch(getCompanyNumbers(token, id, uid)),
  getNumberByID: (token, id) => dispatch(getNumberByID(token, id)),
  uploadFile: (token, id, files) => dispatch(uploadFile(token, id, files)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditNumberForm);
